module.exports = __webpack_public_path__ + "img/down-arrow.bed836ef.svg";